module.exports = __webpack_public_path__ + "6daaac1a7313720f8d7eb72a61bb1a9d.png";